import { useQuery } from "@tanstack/react-query";

import { organizationProvidersQueryOptionsFactory } from "~/providers/factories/organizationProvidersQueryOptionsFactory";

export const useOrganizationProviders = (organizationId: string) => {
  return useQuery(
    organizationProvidersQueryOptionsFactory.list(organizationId),
  );
};
